import type {
  AnyApiFactory,
} from "@backstage/core-plugin-api";
import {
  bitbucketAuthApiRef,
  configApiRef,
  createApiFactory,
  githubAuthApiRef,
} from "@backstage/core-plugin-api";
import {
  ScmAuth,
  scmAuthApiRef,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from "@backstage/integration-react";



export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: scmAuthApiRef,
    deps: {
      bitbucket: bitbucketAuthApiRef,
      github: githubAuthApiRef,
    },
    factory: ({ bitbucket, github }) => ScmAuth.merge(
      ScmAuth.forBitbucket(
        bitbucket,
        {
          scopeMapping: {
            default: [
              "account",
              "pullrequest",
              "snippet",
              "issue",
              "project",
              "repository",
            ],
          },
        },
      ),
      ScmAuth.forGithub(github),
    ),
  }),
];
